var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttachFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2276_2280)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.13541 2.29623C10.9936 0.438018 14.0064 0.438019 15.8646 2.29623C17.7228 4.15444 17.7228 7.1672 15.8646 9.02541L13.9486 10.9414C13.9431 10.9471 13.9376 10.9528 13.932 10.9583L10.5498 14.3406C9.22528 15.6651 7.07783 15.6651 5.75332 14.3406C4.42881 13.0161 4.42881 10.8686 5.75332 9.54413L9.61875 5.6787C10.0093 5.28818 10.6424 5.28818 11.033 5.6787C11.4235 6.06923 11.4235 6.70239 11.033 7.09292L7.16753 10.9583C6.62407 11.5018 6.62407 12.3829 7.16753 12.9264C7.71099 13.4698 8.59211 13.4698 9.13557 12.9264L10.81 11.2519C10.8155 11.2462 10.821 11.2406 10.8265 11.235L14.4504 7.6112C15.5275 6.53403 15.5275 4.78761 14.4504 3.71044C13.3732 2.63328 11.6268 2.63328 10.5496 3.71044L8.87425 5.38581L8.85861 5.4018L4.75159 9.50882C3.14073 11.1197 3.14073 13.7314 4.75159 15.3423C6.36246 16.9532 8.97419 16.9532 10.5851 15.3423L14.6921 11.2353C15.0826 10.8447 15.7158 10.8447 16.1063 11.2353C16.4968 11.6258 16.4968 12.259 16.1063 12.6495L11.9993 16.7565C9.60736 19.1484 5.7293 19.1484 3.33738 16.7565C0.945465 14.3646 0.945464 10.4865 3.33738 8.09461L5.49592 5.93607L5.51157 5.92007L9.13541 2.29623Z",
    fill: "#151C22"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2276_2280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachFile);
export default __webpack_public_path__ + "static/media/attach-file.ebbc1612.svg";
export { ForwardRef as ReactComponent };